import React from 'react'

const FOOTER_SLOTS = [
  { id: 'history', label: 'History' },
  { id: 'milestones', label: 'Milestones' },
  { id: 'rewards', label: 'Rewards' }
] as const

/** Global product footer. Not part of match controls. */
export const GlobalFooter: React.FC = () => {
  return (
    <footer className="global-footer" aria-label="Game sections">
      {FOOTER_SLOTS.map((slot) => (
        <button
          key={slot.id}
          type="button"
          className="footer-slot"
          disabled
          title="Coming later"
        >
          {slot.label}
        </button>
      ))}
    </footer>
  )
}
